import { Button, Container, Typography } from '@/ui-kit';
import styles from './liked-list.module.scss';
import { ErrorNotificationIcon, MagicStick, ModerationPendingIcon, RemoderationIcon, SuccessNotificationIcon } from '@/assets/icons';
import { routesApp } from '@/constans/routes';
import { useAuth } from '@/store/useAuth';
import { Like } from '@/types/profile';
import { LikedItem } from './componenets/liked-item';
import { VoteProfileDto } from '@/api/profiles';
import { useVoteProfileById } from '@/hooks/use-vote-profile-by-id';
import React from 'react';
import { useToast } from '@/store/useToast';
import clsx from 'clsx';
import WebApp from '@twa-dev/sdk';
import { useVibration } from '@/store/useVibration';
import { HalfDone } from '../half-done';

interface Props {
    paidLikes: Like[];
    freeLikes: Like[];
    refetchData?: () => void;
}

export const LikedList: React.FC<Props> = ({ paidLikes = [], freeLikes = [], refetchData }) => {
    const userData = useAuth((state) => state.getUser());
    const showToast = useToast((state) => state.show);
    const { mutateAsync: voteProfileById } = useVoteProfileById();
    const handleVoteProfileById = async (profileId: number, voteProfileDto: VoteProfileDto) => {
        try {
            const { data } = await voteProfileById({
                profileId,
                voteProfileDto,
            });

            if (voteProfileDto.value === false) {
                refetchData?.();
            }

            if (voteProfileDto.value === true) {
                refetchData?.();
            }

            showToast({
                icon: <SuccessNotificationIcon />,
                msg: voteProfileDto.value ? 'Лайк поставлен' : 'Дизлайк поставлен'
            });
        } catch (e) {
            showToast({
                // type error
                icon: <ErrorNotificationIcon />,
                msg: 'Ошибка. Попробуйте ещё раз'
            });
        }
    };
    const isPaid = userData?.is_paid;

    const noLikeYet = (
        <div className={styles.noLike}>
            <div className={styles.noLike__dekor} />
            <Typography
                className={styles.noLike__title}
                center
                fontWeight="semibold"
                fontFamily="SFProText">
                У вас пока нет лайков
            </Typography>

            <Typography
                className={styles.noLike__titleText}
                center
                fontWeight="semibold"
                fontFamily="SFProText">
                Лайкайте профили и совсем скоро тебя <br /> найдёт кто-то особенный!
            </Typography>

            <Button
                className={styles.noLike__button}
                isLink
                to={routesApp.browse}
                typeColor="orange"
                textColor="white">
                Найти пару
            </Button>
        </div>
    );

    const paidProfileList =
        userData
            ?.moderation_status
            === 'change_required' ?
            (
                userData
                    .violations_resolved ?
                    <div className={styles.remoderationCard}>
                        <ModerationPendingIcon
                            width={56}
                            height={56}
                            className={styles.remoderationCardIconPending} />
                        <Typography
                            className={styles.moderationTitle}
                            center
                            fontWeight="semibold"
                            fontFamily="SFProText">
                            Твоя анкета на проверке
                        </Typography>

                        <Typography
                            center
                            fontFamily="SFProText"
                            className={styles.moderationSubtitle}>
                            Сейчас проверяем твои данные, обычно это занимает немного времени
                        </Typography>
                    </div>
                :
                    <div className={styles.remoderationCard}>
                        <RemoderationIcon
                            width={56}
                            height={56}
                            className={styles.remoderationCardIcon} />
                        <Typography
                            className={styles.moderationTitle}
                            center
                            fontWeight="semibold"
                            fontFamily="SFProText">
                            Отредактируй свои данные,<br />чтобы пройти модерацию
                        </Typography>

                        <Typography
                            center
                            fontFamily="SFProText"
                            className={styles.moderationSubtitle}>
                            После прохождения проверки твой профиль будет показываться в ленте и тебя смогут лайкать
                        </Typography>

                        <Button
                            className={styles.moderationBtn}
                            isLink
                            to={routesApp.profileEdit}
                            typeColor="orange"
                            textColor="white">
                            Перейти в профиль
                        </Button>
                    </div>
            )
        : paidLikes.length > 0 ?
            <div className={clsx(!isPaid && styles.paidLikesForUnpremiumUser)}>
                <Typography
                    className={styles.premiumLikesTitle}
                    fontWeight="semibold"
                    fontFamily="SFProText">
                    Premium лайки
                </Typography>
                {
                    paidLikes.map(like => (
                        <LikedItem
                            key={like.id}
                            like={like}
                            isPaid={
                                (isPaid || false) ||
                                like.profile.is_paid
                            }
                            onVoteProfile={value => handleVoteProfileById(like.profile.id, { value })} />
                    ))
                }
            </div>
        :
            <></>;

    const freeProfileList =
        userData
            ?.moderation_status
            === 'change_required' ?
            (
                userData
                    .violations_resolved ?
                    <div className={styles.remoderationCard}>
                        <ModerationPendingIcon
                            width={56}
                            height={56}
                            className={styles.remoderationCardIconPending} />
                        <Typography
                            className={styles.moderationTitle}
                            center
                            fontWeight="semibold"
                            fontFamily="SFProText">
                            Твоя анкета на проверке
                        </Typography>

                        <Typography
                            center
                            fontFamily="SFProText"
                            className={styles.moderationSubtitle}>
                            Сейчас проверяем твои данные, обычно это занимает немного времени
                        </Typography>
                    </div>
                :
                    <div className={styles.remoderationCard}>
                        <RemoderationIcon
                            width={56}
                            height={56}
                            className={styles.remoderationCardIcon} />
                        <Typography
                            className={styles.moderationTitle}
                            center
                            fontWeight="semibold"
                            fontFamily="SFProText">
                            Отредактируй свои данные,<br />чтобы пройти модерацию
                        </Typography>

                        <Typography
                            center
                            fontFamily="SFProText"
                            className={styles.moderationSubtitle}>
                            После прохождения проверки твой профиль будет показываться в ленте и тебя смогут лайкать
                        </Typography>

                        <Button
                            className={styles.moderationBtn}
                            isLink
                            to={routesApp.profileEdit}
                            typeColor="orange"
                            textColor="white">
                            Перейти в профиль
                        </Button>
                    </div>
            )
        :
            freeLikes.map(like => (
                <LikedItem
                    key={like.id}
                    like={like}
                    isPaid={
                        (isPaid || false) ||
                        like.profile.is_paid
                    }
                    onVoteProfile={value => handleVoteProfileById(like.profile.id, { value })} />
              ));

    const { isVibrationEnabled } =
        useVibration(state => state);
    
    const onActivatePremiumClick = () => {
        if (isVibrationEnabled) {
            WebApp
                .HapticFeedback
                .impactOccurred('medium');
            // pass for not android
            navigator.vibrate?.(10)
        }
    }

    return (
        <Container
            className={
                clsx(
                    styles.container,
                    (
                        [
                            ...paidLikes,
                            ...freeLikes
                        ]
                            .length === 0 ||
                        userData
                            ?.moderation_status
                            === 'change_required'
                    ) &&
                    styles.containerCenter,
                    (
                        userData
                            ?.moderation_status
                            === 'change_required'
                    ) &&
                    styles.moderationContainer
                )
            }>
            {
                userData
                    ?.moderation_status
                    === 'change_required' ?
                    (
                        userData
                            .violations_resolved ?
                            <div className={styles.remoderationCard}>
                                <ModerationPendingIcon
                                    width={56}
                                    height={56}
                                    className={styles.remoderationCardIconPending} />
                                <Typography
                                    className={styles.moderationTitle}
                                    center
                                    fontWeight="semibold"
                                    fontFamily="SFProText">
                                    Твоя анкета на проверке
                                </Typography>

                                <Typography
                                    center
                                    fontFamily="SFProText"
                                    className={styles.moderationSubtitle}>
                                    Сейчас проверяем твои данные, обычно это занимает немного времени
                                </Typography>
                            </div>
                        :
                            <div className={styles.remoderationCard}>
                                <RemoderationIcon
                                    width={56}
                                    height={56}
                                    className={styles.remoderationCardIcon} />
                                <Typography
                                    className={styles.moderationTitle}
                                    center
                                    fontWeight="semibold"
                                    fontFamily="SFProText">
                                    Отредактируй свои данные,<br />чтобы пройти модерацию
                                </Typography>

                                <Typography
                                    center
                                    fontFamily="SFProText"
                                    className={styles.moderationSubtitle}>
                                    После прохождения проверки твой профиль будет показываться в ленте и тебя смогут лайкать
                                </Typography>

                                <Button
                                    className={styles.moderationBtn}
                                    isLink
                                    to={routesApp.profileEdit}
                                    typeColor="orange"
                                    textColor="white">
                                    Перейти в профиль
                                </Button>
                            </div>
                    )
                : userData?.state === 'half_done' ?
                    <HalfDone variant={'secondary'} />
                : [
                    ...paidLikes,
                    ...freeLikes
                ].length ?
                    <>
                        { paidProfileList }
                        {
                            !isPaid &&
                            [
                                ...paidLikes,
                                ...freeLikes
                            ].length > 0 &&
                            userData
                                ?.moderation_status
                                !== 'change_required' &&
                            <div className={styles.dekorHeart} />
                        }            
                        {
                            !isPaid &&
                            [
                                ...paidLikes,
                                ...freeLikes
                            ].length > 0 && (
                            <Typography
                                className={styles.title}
                                center
                                fontWeight="semibold"
                                fontFamily="SFProText">
                                Кто-то уже поставил тебе лайк!
                            </Typography>
                        )}
                        {
                            !isPaid &&
                            [
                                ...paidLikes,
                                ...freeLikes
                            ].length > 0 && (
                            <>
                                <Typography
                                    center
                                    className={styles.text}
                                    fontWeight="normal"
                                    fontFamily="SFProText"
                                >
                                    Чтобы увидеть, кто именно — активируй премиум. <br />
                                    Или начни лайкать анкеты — если совпадёт, <br />
                                    вы оба узнаете друг о друге!
                                </Typography>
                                <div className={styles.buttonWrapper}>
                                    <Button
                                        typeColor="orange"
                                        className={styles.button}
                                        isLink
                                        to={routesApp.subscription}
                                        onClick={onActivatePremiumClick}>
                                        <span>Активировать Premium</span>
                                        <MagicStick
                                            width={20}
                                            height={20} />
                                    </Button>
                                    <Button
                                        typeColor="white"
                                        className={styles.buttonWhite}
                                        isLink
                                        to={routesApp.browse}
                                    >
                                        <span>К анкетам</span>
                                    </Button>
                                </div>
                            </>
                        )}
                        { freeProfileList }
                    </>
                : noLikeYet
            }
        </Container>
    );
};
